import type {AnalyticsParams} from 'src/internal/analytics/types';
import type {ObservabilityConfig} from 'src/types';

export default function buildParams<T extends string>(
  config: ObservabilityConfig,
  eventName: string,
  parameters?: AnalyticsParams<T>,
): AnalyticsParams<T> | undefined {
  const configParams = config.analytics?.parameters;
  const params = {
    ...(config.page ? {page: config.page} : {}),
    ...(config.project ? {project: config.project} : {}),
    ...(config.userId ? {user_id: config.userId} : {}),
    ...(config.release ? {release: config.release} : {}),
    ...(config.boundaryViewToken
      ? {boundary_view_token: config.boundaryViewToken}
      : {}),
    ...(configParams?.['*'] as any),
    ...(configParams?.[eventName] as any),
    ...parameters,
  };

  if (Object.keys(params).length === 0) {
    return undefined;
  }

  return params;
}
